module.exports = __webpack_public_path__ + "assets/img/gift-success-a4d406ca.png";